import { render, staticRenderFns } from "./PortfolioCard.vue?vue&type=template&id=336b9678&"
import script from "./PortfolioCard.vue?vue&type=script&lang=js&"
export * from "./PortfolioCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports